import React from 'react';
import ThemePanel from './mainMenu/ThemePanel';
import { useChaos } from './shared/chaos/useChaos';
import { useAnimations } from './shared/animations/useAnimations';
import { useTheme } from './shared/theme/useTheme';

/**
 * Root wrapper. Initializes all global systems once so they apply
 * on every route: chaos level, theme, and animations toggle.
 */
export default function AppShell({ children }: { children: React.ReactNode }) {
  useChaos();
  useAnimations(); // applies data-animations to body
  useTheme();      // applies data-theme to body

  return (
    <>
      <ThemePanel />
      {children}
    </>
  );
}
